"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * auth
 * Centralized authentication service for Engine by MoneyLion
 *
 * The version of the OpenAPI document: 1.11.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApi = exports.ServiceApiFactory = exports.ServiceApiFp = exports.ServiceApiAxiosParamCreator = exports.ScopeApi = exports.ScopeApiFactory = exports.ScopeApiFp = exports.ScopeApiAxiosParamCreator = exports.RoleApi = exports.RoleApiFactory = exports.RoleApiFp = exports.RoleApiAxiosParamCreator = exports.PasswordApi = exports.PasswordApiFactory = exports.PasswordApiFp = exports.PasswordApiAxiosParamCreator = exports.CompanyApi = exports.CompanyApiFactory = exports.CompanyApiFp = exports.CompanyApiAxiosParamCreator = exports.AwsApi = exports.AwsApiFactory = exports.AwsApiFp = exports.AwsApiAxiosParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiAxiosParamCreator = exports.ApplicationApi = exports.ApplicationApiFactory = exports.ApplicationApiFp = exports.ApplicationApiAxiosParamCreator = exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = exports.AccessTokenApi = exports.AccessTokenApiFactory = exports.AccessTokenApiFp = exports.AccessTokenApiAxiosParamCreator = exports.UserSort = exports.UserDeactivationReason = exports.ScopeSort = exports.RoleSort = exports.Order = exports.IntegrationType = exports.FinanceAccountTierType = exports.ApplicationSort = exports.AccountSort = exports.AccessTokenSort = void 0;
exports.UserDeactivationApi = exports.UserDeactivationApiFactory = exports.UserDeactivationApiFp = exports.UserDeactivationApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AccessTokenSort = {
    CreatedAt: 'created_at',
    DeletedAt: 'deleted_at',
    Id: 'id'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AccountSort = {
    CreatedAt: 'created_at',
    DeletedAt: 'deleted_at'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ApplicationSort = {
    CreatedAt: 'created_at',
    DeletedAt: 'deleted_at',
    Id: 'id',
    Name: 'name'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FinanceAccountTierType = {
    Growth: 'growth',
    Internal: 'internal',
    Legacy: 'legacy',
    Scale: 'scale',
    Starter: 'starter',
    StarterLegacy: 'starter_legacy',
    Trial: 'trial'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IntegrationType = {
    AffiliateLinks: 'affiliate_links',
    ApiCherryPick: 'api_cherry_pick',
    ApiMobile: 'api_mobile',
    ApiOfferWall: 'api_offer_wall',
    CreditComEmbed: 'credit_com_embed',
    MpsEmbedEven: 'mps_embed_even',
    MpsEmbedFiona: 'mps_embed_fiona',
    ThreeStepMpsEmbedEven: 'three_step_mps_embed_even',
    ThreeStepMpsEmbedFiona: 'three_step_mps_embed_fiona',
    MobileSdk: 'mobile_sdk',
    MpsPartnerPageEven: 'mps_partner_page_even',
    MpsPartnerPageFiona: 'mps_partner_page_fiona',
    Cla: 'cla',
    Pls: 'pls'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Order = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RoleSort = {
    CreatedAt: 'created_at',
    DeletedAt: 'deleted_at',
    Id: 'id',
    Key: 'key'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ScopeSort = {
    CreatedAt: 'created_at',
    DeletedAt: 'deleted_at',
    Key: 'key'
};
/**
 * Reasons why a user was deactivated
 * @export
 * @enum {string}
 */
exports.UserDeactivationReason = {
    Migration: 'migration',
    SubscriptionExpired: 'subscriptionExpired',
    UserAction: 'userAction',
    Rejected: 'rejected'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UserSort = {
    CreatedAt: 'created_at',
    DeletedAt: 'deleted_at',
    Id: 'id',
    Name: 'name'
};
/**
 * AccessTokenApi - axios parameter creator
 * @export
 */
var AccessTokenApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create an access token
         * @summary Create an access token
         * @param {AccessTokenCreateData} [accessTokenCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken: function (accessTokenCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessTokenCreateData_1], args_1, true), void 0, function (accessTokenCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accessTokens";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["create:access-token"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessTokenCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create an access token
         * @summary Create an access token
         * @param {AccessTokenCreateData} [accessTokenCreateData]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAccessTokenDeprecated: function (accessTokenCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessTokenCreateData_1], args_1, true), void 0, function (accessTokenCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/access_tokens";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["create:access-token"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessTokenCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an access token
         * @summary Delete an access token
         * @param {number} parameter Access token ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessToken: function (parameter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([parameter_1], args_1, true), void 0, function (parameter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameter' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAccessToken', 'parameter', parameter);
                            localVarPath = "/accessTokens/{parameter}"
                                .replace("{".concat("parameter", "}"), encodeURIComponent(String(parameter)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get access token object for access token
         * @summary Get access token object
         * @param {string} parameter String representation of access token \&#39;uuid_secret\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken: function (parameter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([parameter_1], args_1, true), void 0, function (parameter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameter' is not null or undefined
                            (0, common_1.assertParamExists)('getAccessToken', 'parameter', parameter);
                            localVarPath = "/accessTokens/{parameter}"
                                .replace("{".concat("parameter", "}"), encodeURIComponent(String(parameter)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["svc-auth:get:access-token"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get access token object for access token
         * @summary Get access token object
         * @param {string} accessTokenStr String representation of access token \&#39;uuid_secret\&#39;
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccessTokenDeprecated: function (accessTokenStr_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessTokenStr_1], args_1, true), void 0, function (accessTokenStr, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accessTokenStr' is not null or undefined
                            (0, common_1.assertParamExists)('getAccessTokenDeprecated', 'accessTokenStr', accessTokenStr);
                            localVarPath = "/access_tokens/{accessTokenStr}"
                                .replace("{".concat("accessTokenStr", "}"), encodeURIComponent(String(accessTokenStr)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["svc-auth:get:access-token"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get access tokens
         * @summary Get access tokens
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [resourceOwnerId]
         * @param {Array<number>} [clientId]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {boolean} [excludeDeleted]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {AccessTokenSort} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessTokens: function (id_1, uuid_1, resourceOwnerId_1, clientId_1, createdById_1, deletedById_1, excludeDeleted_1, offset_1, limit_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 11; _i < arguments.length; _i++) {
                args_1[_i - 11] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, uuid_1, resourceOwnerId_1, clientId_1, createdById_1, deletedById_1, excludeDeleted_1, offset_1, limit_1, sortBy_1, order_1], args_1, true), void 0, function (id, uuid, resourceOwnerId, clientId, createdById, deletedById, excludeDeleted, offset, limit, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accessTokens";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (resourceOwnerId) {
                                localVarQueryParameter['resourceOwnerId'] = resourceOwnerId;
                            }
                            if (clientId) {
                                localVarQueryParameter['clientId'] = clientId;
                            }
                            if (createdById) {
                                localVarQueryParameter['createdById'] = createdById;
                            }
                            if (deletedById) {
                                localVarQueryParameter['deletedById'] = deletedById;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return rich access tokens based upon request parameters
         * @summary Get rich access tokens
         * @param {Array<number>} [id]
         * @param {Array<string>} [accessTokenUuid]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRichAccessTokens: function (id_1, accessTokenUuid_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, accessTokenUuid_1, limit_1], args_1, true), void 0, function (id, accessTokenUuid, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/richAccessTokens";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["list:account"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (accessTokenUuid) {
                                localVarQueryParameter['accessTokenUuid'] = accessTokenUuid;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccessTokenApiAxiosParamCreator = AccessTokenApiAxiosParamCreator;
/**
 * AccessTokenApi - functional programming interface
 * @export
 */
var AccessTokenApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccessTokenApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create an access token
         * @summary Create an access token
         * @param {AccessTokenCreateData} [accessTokenCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken: function (accessTokenCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccessToken(accessTokenCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccessTokenApi.createAccessToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create an access token
         * @summary Create an access token
         * @param {AccessTokenCreateData} [accessTokenCreateData]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAccessTokenDeprecated: function (accessTokenCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccessTokenDeprecated(accessTokenCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccessTokenApi.createAccessTokenDeprecated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete an access token
         * @summary Delete an access token
         * @param {number} parameter Access token ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessToken: function (parameter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAccessToken(parameter, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccessTokenApi.deleteAccessToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get access token object for access token
         * @summary Get access token object
         * @param {string} parameter String representation of access token \&#39;uuid_secret\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken: function (parameter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccessToken(parameter, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccessTokenApi.getAccessToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get access token object for access token
         * @summary Get access token object
         * @param {string} accessTokenStr String representation of access token \&#39;uuid_secret\&#39;
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccessTokenDeprecated: function (accessTokenStr, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccessTokenDeprecated(accessTokenStr, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccessTokenApi.getAccessTokenDeprecated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get access tokens
         * @summary Get access tokens
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [resourceOwnerId]
         * @param {Array<number>} [clientId]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {boolean} [excludeDeleted]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {AccessTokenSort} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessTokens: function (id, uuid, resourceOwnerId, clientId, createdById, deletedById, excludeDeleted, offset, limit, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccessTokens(id, uuid, resourceOwnerId, clientId, createdById, deletedById, excludeDeleted, offset, limit, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccessTokenApi.getAccessTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return rich access tokens based upon request parameters
         * @summary Get rich access tokens
         * @param {Array<number>} [id]
         * @param {Array<string>} [accessTokenUuid]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRichAccessTokens: function (id, accessTokenUuid, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRichAccessTokens(id, accessTokenUuid, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccessTokenApi.getRichAccessTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AccessTokenApiFp = AccessTokenApiFp;
/**
 * AccessTokenApi - factory interface
 * @export
 */
var AccessTokenApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccessTokenApiFp)(configuration);
    return {
        /**
         * Create an access token
         * @summary Create an access token
         * @param {AccessTokenApiCreateAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createAccessToken(requestParameters.accessTokenCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create an access token
         * @summary Create an access token
         * @param {AccessTokenApiCreateAccessTokenDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createAccessTokenDeprecated: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createAccessTokenDeprecated(requestParameters.accessTokenCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an access token
         * @summary Delete an access token
         * @param {AccessTokenApiDeleteAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessToken: function (requestParameters, options) {
            return localVarFp.deleteAccessToken(requestParameters.parameter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get access token object for access token
         * @summary Get access token object
         * @param {AccessTokenApiGetAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken: function (requestParameters, options) {
            return localVarFp.getAccessToken(requestParameters.parameter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get access token object for access token
         * @summary Get access token object
         * @param {AccessTokenApiGetAccessTokenDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccessTokenDeprecated: function (requestParameters, options) {
            return localVarFp.getAccessTokenDeprecated(requestParameters.accessTokenStr, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get access tokens
         * @summary Get access tokens
         * @param {AccessTokenApiGetAccessTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessTokens: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getAccessTokens(requestParameters.id, requestParameters.uuid, requestParameters.resourceOwnerId, requestParameters.clientId, requestParameters.createdById, requestParameters.deletedById, requestParameters.excludeDeleted, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return rich access tokens based upon request parameters
         * @summary Get rich access tokens
         * @param {AccessTokenApiGetRichAccessTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRichAccessTokens: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getRichAccessTokens(requestParameters.id, requestParameters.accessTokenUuid, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccessTokenApiFactory = AccessTokenApiFactory;
/**
 * AccessTokenApi - object-oriented interface
 * @export
 * @class AccessTokenApi
 * @extends {BaseAPI}
 */
var AccessTokenApi = /** @class */ (function (_super) {
    __extends(AccessTokenApi, _super);
    function AccessTokenApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an access token
     * @summary Create an access token
     * @param {AccessTokenApiCreateAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessTokenApi
     */
    AccessTokenApi.prototype.createAccessToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccessTokenApiFp)(this.configuration).createAccessToken(requestParameters.accessTokenCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create an access token
     * @summary Create an access token
     * @param {AccessTokenApiCreateAccessTokenDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccessTokenApi
     */
    AccessTokenApi.prototype.createAccessTokenDeprecated = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccessTokenApiFp)(this.configuration).createAccessTokenDeprecated(requestParameters.accessTokenCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an access token
     * @summary Delete an access token
     * @param {AccessTokenApiDeleteAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessTokenApi
     */
    AccessTokenApi.prototype.deleteAccessToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccessTokenApiFp)(this.configuration).deleteAccessToken(requestParameters.parameter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get access token object for access token
     * @summary Get access token object
     * @param {AccessTokenApiGetAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessTokenApi
     */
    AccessTokenApi.prototype.getAccessToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccessTokenApiFp)(this.configuration).getAccessToken(requestParameters.parameter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get access token object for access token
     * @summary Get access token object
     * @param {AccessTokenApiGetAccessTokenDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccessTokenApi
     */
    AccessTokenApi.prototype.getAccessTokenDeprecated = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccessTokenApiFp)(this.configuration).getAccessTokenDeprecated(requestParameters.accessTokenStr, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get access tokens
     * @summary Get access tokens
     * @param {AccessTokenApiGetAccessTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessTokenApi
     */
    AccessTokenApi.prototype.getAccessTokens = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccessTokenApiFp)(this.configuration).getAccessTokens(requestParameters.id, requestParameters.uuid, requestParameters.resourceOwnerId, requestParameters.clientId, requestParameters.createdById, requestParameters.deletedById, requestParameters.excludeDeleted, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return rich access tokens based upon request parameters
     * @summary Get rich access tokens
     * @param {AccessTokenApiGetRichAccessTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessTokenApi
     */
    AccessTokenApi.prototype.getRichAccessTokens = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccessTokenApiFp)(this.configuration).getRichAccessTokens(requestParameters.id, requestParameters.accessTokenUuid, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccessTokenApi;
}(base_1.BaseAPI));
exports.AccessTokenApi = AccessTokenApi;
/**
 * AccountApi - axios parameter creator
 * @export
 */
var AccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create an account
         * @summary Create an account
         * @param {AccountCreateData} [accountCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (accountCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accountCreateData_1], args_1, true), void 0, function (accountCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["create:account"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return account for a UUID
         * @summary Get one account
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getAccount', 'uuid', uuid);
                            localVarPath = "/accounts/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:account"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get access tokens for account
         * @summary Get access tokens for account
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessTokens: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getAccountAccessTokens', 'uuid', uuid);
                            localVarPath = "/accounts/{uuid}/access_tokens"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:account"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get UserCompany for account
         * @summary Get UserCompany for account
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccountUserCompany: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getAccountUserCompany', 'uuid', uuid);
                            localVarPath = "/accounts/{uuid}/user_company"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:account"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return accounts based upon request parameters
         * @summary Get accounts
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<string>} [createdById]
         * @param {Array<string>} [deletedById]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {AccountSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: function (limit_1, id_1, uuid_1, createdById_1, deletedById_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, createdById_1, deletedById_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, createdById, deletedById, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getAccounts', 'limit', limit);
                            localVarPath = "/accounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["list:account"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (createdById) {
                                localVarQueryParameter['createdById'] = createdById;
                            }
                            if (deletedById) {
                                localVarQueryParameter['deletedById'] = deletedById;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return rich accounts based upon request parameters
         * @summary Get rich accounts
         * @param {Array<number>} [id]
         * @param {Array<string>} [accessTokenUuid]
         * @param {Array<string>} [accountUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRichAccounts: function (id_1, accessTokenUuid_1, accountUuid_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, accessTokenUuid_1, accountUuid_1], args_1, true), void 0, function (id, accessTokenUuid, accountUuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/richAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["list:account"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (accessTokenUuid) {
                                localVarQueryParameter['accessTokenUuid'] = accessTokenUuid;
                            }
                            if (accountUuid) {
                                localVarQueryParameter['accountUuid'] = accountUuid;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update an account
         * @summary Update an account
         * @param {AccountUpdateData} [accountUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: function (accountUpdateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accountUpdateData_1], args_1, true), void 0, function (accountUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["update:account"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountApiAxiosParamCreator = AccountApiAxiosParamCreator;
/**
 * AccountApi - functional programming interface
 * @export
 */
var AccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create an account
         * @summary Create an account
         * @param {AccountCreateData} [accountCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (accountCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccount(accountCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.createAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return account for a UUID
         * @summary Get one account
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccount(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get access tokens for account
         * @summary Get access tokens for account
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessTokens: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountAccessTokens(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getAccountAccessTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get UserCompany for account
         * @summary Get UserCompany for account
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccountUserCompany: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountUserCompany(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getAccountUserCompany']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return accounts based upon request parameters
         * @summary Get accounts
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<string>} [createdById]
         * @param {Array<string>} [deletedById]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {AccountSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: function (limit, id, uuid, createdById, deletedById, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccounts(limit, id, uuid, createdById, deletedById, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return rich accounts based upon request parameters
         * @summary Get rich accounts
         * @param {Array<number>} [id]
         * @param {Array<string>} [accessTokenUuid]
         * @param {Array<string>} [accountUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRichAccounts: function (id, accessTokenUuid, accountUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRichAccounts(id, accessTokenUuid, accountUuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getRichAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update an account
         * @summary Update an account
         * @param {AccountUpdateData} [accountUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: function (accountUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAccount(accountUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.updateAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AccountApiFp = AccountApiFp;
/**
 * AccountApi - factory interface
 * @export
 */
var AccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountApiFp)(configuration);
    return {
        /**
         * Create an account
         * @summary Create an account
         * @param {AccountApiCreateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createAccount(requestParameters.accountCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return account for a UUID
         * @summary Get one account
         * @param {AccountApiGetAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: function (requestParameters, options) {
            return localVarFp.getAccount(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get access tokens for account
         * @summary Get access tokens for account
         * @param {AccountApiGetAccountAccessTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessTokens: function (requestParameters, options) {
            return localVarFp.getAccountAccessTokens(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get UserCompany for account
         * @summary Get UserCompany for account
         * @param {AccountApiGetAccountUserCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccountUserCompany: function (requestParameters, options) {
            return localVarFp.getAccountUserCompany(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return accounts based upon request parameters
         * @summary Get accounts
         * @param {AccountApiGetAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: function (requestParameters, options) {
            return localVarFp.getAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.createdById, requestParameters.deletedById, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return rich accounts based upon request parameters
         * @summary Get rich accounts
         * @param {AccountApiGetRichAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRichAccounts: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getRichAccounts(requestParameters.id, requestParameters.accessTokenUuid, requestParameters.accountUuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an account
         * @summary Update an account
         * @param {AccountApiUpdateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.updateAccount(requestParameters.accountUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountApiFactory = AccountApiFactory;
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
var AccountApi = /** @class */ (function (_super) {
    __extends(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an account
     * @summary Create an account
     * @param {AccountApiCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.createAccount = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccountApiFp)(this.configuration).createAccount(requestParameters.accountCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return account for a UUID
     * @summary Get one account
     * @param {AccountApiGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).getAccount(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get access tokens for account
     * @summary Get access tokens for account
     * @param {AccountApiGetAccountAccessTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccountAccessTokens = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).getAccountAccessTokens(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get UserCompany for account
     * @summary Get UserCompany for account
     * @param {AccountApiGetAccountUserCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccountUserCompany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).getAccountUserCompany(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return accounts based upon request parameters
     * @summary Get accounts
     * @param {AccountApiGetAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccounts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).getAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.createdById, requestParameters.deletedById, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return rich accounts based upon request parameters
     * @summary Get rich accounts
     * @param {AccountApiGetRichAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getRichAccounts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccountApiFp)(this.configuration).getRichAccounts(requestParameters.id, requestParameters.accessTokenUuid, requestParameters.accountUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an account
     * @summary Update an account
     * @param {AccountApiUpdateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.updateAccount = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccountApiFp)(this.configuration).updateAccount(requestParameters.accountUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountApi;
}(base_1.BaseAPI));
exports.AccountApi = AccountApi;
/**
 * ApplicationApi - axios parameter creator
 * @export
 */
var ApplicationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create an application
         * @summary Create an application
         * @param {ApplicationCreateData} [applicationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplication: function (applicationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([applicationCreateData_1], args_1, true), void 0, function (applicationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/applications";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(applicationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a application
         * @summary Delete a application
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplication: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteApplication', 'id', id);
                            localVarPath = "/applications/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return applications based upon request parameters
         * @summary Get applications
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [accountId]
         * @param {Array<string>} [companyUuid]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {ApplicationSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplications: function (limit_1, id_1, uuid_1, accountId_1, companyUuid_1, createdById_1, deletedById_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 10; _i < arguments.length; _i++) {
                args_1[_i - 10] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, accountId_1, companyUuid_1, createdById_1, deletedById_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, accountId, companyUuid, createdById, deletedById, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getApplications', 'limit', limit);
                            localVarPath = "/applications";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId;
                            }
                            if (companyUuid) {
                                localVarQueryParameter['companyUuid'] = companyUuid;
                            }
                            if (createdById) {
                                localVarQueryParameter['createdById'] = createdById;
                            }
                            if (deletedById) {
                                localVarQueryParameter['deletedById'] = deletedById;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ApplicationApiAxiosParamCreator = ApplicationApiAxiosParamCreator;
/**
 * ApplicationApi - functional programming interface
 * @export
 */
var ApplicationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplicationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create an application
         * @summary Create an application
         * @param {ApplicationCreateData} [applicationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplication: function (applicationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createApplication(applicationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicationApi.createApplication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a application
         * @summary Delete a application
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplication: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteApplication(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicationApi.deleteApplication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return applications based upon request parameters
         * @summary Get applications
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [accountId]
         * @param {Array<string>} [companyUuid]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {ApplicationSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplications: function (limit, id, uuid, accountId, companyUuid, createdById, deletedById, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getApplications(limit, id, uuid, accountId, companyUuid, createdById, deletedById, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApplicationApi.getApplications']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ApplicationApiFp = ApplicationApiFp;
/**
 * ApplicationApi - factory interface
 * @export
 */
var ApplicationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplicationApiFp)(configuration);
    return {
        /**
         * Create an application
         * @summary Create an application
         * @param {ApplicationApiCreateApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplication: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createApplication(requestParameters.applicationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a application
         * @summary Delete a application
         * @param {ApplicationApiDeleteApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplication: function (requestParameters, options) {
            return localVarFp.deleteApplication(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return applications based upon request parameters
         * @summary Get applications
         * @param {ApplicationApiGetApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplications: function (requestParameters, options) {
            return localVarFp.getApplications(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.companyUuid, requestParameters.createdById, requestParameters.deletedById, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplicationApiFactory = ApplicationApiFactory;
/**
 * ApplicationApi - object-oriented interface
 * @export
 * @class ApplicationApi
 * @extends {BaseAPI}
 */
var ApplicationApi = /** @class */ (function (_super) {
    __extends(ApplicationApi, _super);
    function ApplicationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an application
     * @summary Create an application
     * @param {ApplicationApiCreateApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.createApplication = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApplicationApiFp)(this.configuration).createApplication(requestParameters.applicationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a application
     * @summary Delete a application
     * @param {ApplicationApiDeleteApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.deleteApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).deleteApplication(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return applications based upon request parameters
     * @summary Get applications
     * @param {ApplicationApiGetApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.getApplications = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).getApplications(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.companyUuid, requestParameters.createdById, requestParameters.deletedById, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplicationApi;
}(base_1.BaseAPI));
exports.ApplicationApi = ApplicationApi;
/**
 * AuthApi - axios parameter creator
 * @export
 */
var AuthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Exchange a bearer token for its access token
         * @summary Authenticate a bearer token
         * @param {AuthCreateData} [authCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuth: function (authCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authCreateData_1], args_1, true), void 0, function (authCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/auths";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(authCreateData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a new access token using email / password pair
         * @summary Create a user login
         * @param {LoginCreateData} [loginCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogin: function (loginCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([loginCreateData_1], args_1, true), void 0, function (loginCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/logins";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginCreateData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the user and company details for a given access token
         * @summary Get authentication details for a given access token
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuth: function (accessToken_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1], args_1, true), void 0, function (accessToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accessToken' is not null or undefined
                            (0, common_1.assertParamExists)('getAuth', 'accessToken', accessToken);
                            localVarPath = "/auths/{accessToken}"
                                .replace("{".concat("accessToken", "}"), encodeURIComponent(String(accessToken)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:auth"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AuthApiAxiosParamCreator = AuthApiAxiosParamCreator;
/**
 * AuthApi - functional programming interface
 * @export
 */
var AuthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthApiAxiosParamCreator)(configuration);
    return {
        /**
         * Exchange a bearer token for its access token
         * @summary Authenticate a bearer token
         * @param {AuthCreateData} [authCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuth: function (authCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAuth(authCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.createAuth']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a new access token using email / password pair
         * @summary Create a user login
         * @param {LoginCreateData} [loginCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogin: function (loginCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLogin(loginCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.createLogin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the user and company details for a given access token
         * @summary Get authentication details for a given access token
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuth: function (accessToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuth(accessToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.getAuth']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AuthApiFp = AuthApiFp;
/**
 * AuthApi - factory interface
 * @export
 */
var AuthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthApiFp)(configuration);
    return {
        /**
         * Exchange a bearer token for its access token
         * @summary Authenticate a bearer token
         * @param {AuthApiCreateAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuth: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createAuth(requestParameters.authCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new access token using email / password pair
         * @summary Create a user login
         * @param {AuthApiCreateLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogin: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createLogin(requestParameters.loginCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the user and company details for a given access token
         * @summary Get authentication details for a given access token
         * @param {AuthApiGetAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuth: function (requestParameters, options) {
            return localVarFp.getAuth(requestParameters.accessToken, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthApiFactory = AuthApiFactory;
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
var AuthApi = /** @class */ (function (_super) {
    __extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Exchange a bearer token for its access token
     * @summary Authenticate a bearer token
     * @param {AuthApiCreateAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.createAuth = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AuthApiFp)(this.configuration).createAuth(requestParameters.authCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new access token using email / password pair
     * @summary Create a user login
     * @param {AuthApiCreateLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.createLogin = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AuthApiFp)(this.configuration).createLogin(requestParameters.loginCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the user and company details for a given access token
     * @summary Get authentication details for a given access token
     * @param {AuthApiGetAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.getAuth = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).getAuth(requestParameters.accessToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthApi;
}(base_1.BaseAPI));
exports.AuthApi = AuthApi;
/**
 * AwsApi - axios parameter creator
 * @export
 */
var AwsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get s3 file upload credentials
         * @summary Get s3 file upload credentials
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getS3FileUploadCredentials: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/thirdPartyCredentials/s3FileUpload";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:user"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AwsApiAxiosParamCreator = AwsApiAxiosParamCreator;
/**
 * AwsApi - functional programming interface
 * @export
 */
var AwsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AwsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get s3 file upload credentials
         * @summary Get s3 file upload credentials
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getS3FileUploadCredentials: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getS3FileUploadCredentials(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AwsApi.getS3FileUploadCredentials']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AwsApiFp = AwsApiFp;
/**
 * AwsApi - factory interface
 * @export
 */
var AwsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AwsApiFp)(configuration);
    return {
        /**
         * Get s3 file upload credentials
         * @summary Get s3 file upload credentials
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getS3FileUploadCredentials: function (options) {
            return localVarFp.getS3FileUploadCredentials(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AwsApiFactory = AwsApiFactory;
/**
 * AwsApi - object-oriented interface
 * @export
 * @class AwsApi
 * @extends {BaseAPI}
 */
var AwsApi = /** @class */ (function (_super) {
    __extends(AwsApi, _super);
    function AwsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get s3 file upload credentials
     * @summary Get s3 file upload credentials
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AwsApi
     */
    AwsApi.prototype.getS3FileUploadCredentials = function (options) {
        var _this = this;
        return (0, exports.AwsApiFp)(this.configuration).getS3FileUploadCredentials(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AwsApi;
}(base_1.BaseAPI));
exports.AwsApi = AwsApi;
/**
 * CompanyApi - axios parameter creator
 * @export
 */
var CompanyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a company
         * @summary Create a company
         * @param {CompanyCreateData} [companyCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: function (companyCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([companyCreateData_1], args_1, true), void 0, function (companyCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/companies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["create:company"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(companyCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return companies based upon request parameters
         * @summary Get companies
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies: function (limit_1, offset_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, offset_1], args_1, true), void 0, function (limit, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getCompanies', 'limit', limit);
                            localVarPath = "/companies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["list:company"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return company for a UUID
         * @summary Get one company
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getCompany', 'uuid', uuid);
                            localVarPath = "/companies/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:company"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return access tokens that belong to a company
         * @summary Get a company\'s access tokens
         * @param {string} companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAccessTokens: function (companyUuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([companyUuid_1], args_1, true), void 0, function (companyUuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyUuid' is not null or undefined
                            (0, common_1.assertParamExists)('getCompanyAccessTokens', 'companyUuid', companyUuid);
                            localVarPath = "/companies/{companyUuid}/accessTokens"
                                .replace("{".concat("companyUuid", "}"), encodeURIComponent(String(companyUuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a company
         * @summary Update a company
         * @param {CompanyUpdateData} [companyUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: function (companyUpdateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([companyUpdateData_1], args_1, true), void 0, function (companyUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/companies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["update:company"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(companyUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CompanyApiAxiosParamCreator = CompanyApiAxiosParamCreator;
/**
 * CompanyApi - functional programming interface
 * @export
 */
var CompanyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CompanyApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a company
         * @summary Create a company
         * @param {CompanyCreateData} [companyCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: function (companyCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCompany(companyCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CompanyApi.createCompany']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return companies based upon request parameters
         * @summary Get companies
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies: function (limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCompanies(limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CompanyApi.getCompanies']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return company for a UUID
         * @summary Get one company
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCompany(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CompanyApi.getCompany']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return access tokens that belong to a company
         * @summary Get a company\'s access tokens
         * @param {string} companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAccessTokens: function (companyUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCompanyAccessTokens(companyUuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CompanyApi.getCompanyAccessTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a company
         * @summary Update a company
         * @param {CompanyUpdateData} [companyUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: function (companyUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCompany(companyUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CompanyApi.updateCompany']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CompanyApiFp = CompanyApiFp;
/**
 * CompanyApi - factory interface
 * @export
 */
var CompanyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CompanyApiFp)(configuration);
    return {
        /**
         * Create a company
         * @summary Create a company
         * @param {CompanyApiCreateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createCompany(requestParameters.companyCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return companies based upon request parameters
         * @summary Get companies
         * @param {CompanyApiGetCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies: function (requestParameters, options) {
            return localVarFp.getCompanies(requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return company for a UUID
         * @summary Get one company
         * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: function (requestParameters, options) {
            return localVarFp.getCompany(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return access tokens that belong to a company
         * @summary Get a company\'s access tokens
         * @param {CompanyApiGetCompanyAccessTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAccessTokens: function (requestParameters, options) {
            return localVarFp.getCompanyAccessTokens(requestParameters.companyUuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a company
         * @summary Update a company
         * @param {CompanyApiUpdateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.updateCompany(requestParameters.companyUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CompanyApiFactory = CompanyApiFactory;
/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
var CompanyApi = /** @class */ (function (_super) {
    __extends(CompanyApi, _super);
    function CompanyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a company
     * @summary Create a company
     * @param {CompanyApiCreateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    CompanyApi.prototype.createCompany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CompanyApiFp)(this.configuration).createCompany(requestParameters.companyCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return companies based upon request parameters
     * @summary Get companies
     * @param {CompanyApiGetCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    CompanyApi.prototype.getCompanies = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CompanyApiFp)(this.configuration).getCompanies(requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return company for a UUID
     * @summary Get one company
     * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    CompanyApi.prototype.getCompany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CompanyApiFp)(this.configuration).getCompany(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return access tokens that belong to a company
     * @summary Get a company\'s access tokens
     * @param {CompanyApiGetCompanyAccessTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    CompanyApi.prototype.getCompanyAccessTokens = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CompanyApiFp)(this.configuration).getCompanyAccessTokens(requestParameters.companyUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a company
     * @summary Update a company
     * @param {CompanyApiUpdateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    CompanyApi.prototype.updateCompany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CompanyApiFp)(this.configuration).updateCompany(requestParameters.companyUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CompanyApi;
}(base_1.BaseAPI));
exports.CompanyApi = CompanyApi;
/**
 * PasswordApi - axios parameter creator
 * @export
 */
var PasswordApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Initiates an email to the specifed a token that can be used change the associated user\'s password
         * @summary Create a password reset request.
         * @param {PasswordResetRequestCreateData} [passwordResetRequestCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: function (passwordResetRequestCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([passwordResetRequestCreateData_1], args_1, true), void 0, function (passwordResetRequestCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/passwords/resetRequests";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(passwordResetRequestCreateData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Updates the email of the user associated with the specified reset request token.
         * @summary Reset a user password via token.
         * @param {PasswordResetCreateData} [passwordResetCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (passwordResetCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([passwordResetCreateData_1], args_1, true), void 0, function (passwordResetCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/passwords/resets";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(passwordResetCreateData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update a user password using email and the existing password.
         * @summary Update a user password
         * @param {PasswordCreateData} [passwordCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: function (passwordCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([passwordCreateData_1], args_1, true), void 0, function (passwordCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/passwords";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(passwordCreateData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PasswordApiAxiosParamCreator = PasswordApiAxiosParamCreator;
/**
 * PasswordApi - functional programming interface
 * @export
 */
var PasswordApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PasswordApiAxiosParamCreator)(configuration);
    return {
        /**
         * Initiates an email to the specifed a token that can be used change the associated user\'s password
         * @summary Create a password reset request.
         * @param {PasswordResetRequestCreateData} [passwordResetRequestCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: function (passwordResetRequestCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestPasswordReset(passwordResetRequestCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PasswordApi.requestPasswordReset']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates the email of the user associated with the specified reset request token.
         * @summary Reset a user password via token.
         * @param {PasswordResetCreateData} [passwordResetCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (passwordResetCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetPassword(passwordResetCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PasswordApi.resetPassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a user password using email and the existing password.
         * @summary Update a user password
         * @param {PasswordCreateData} [passwordCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: function (passwordCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePassword(passwordCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PasswordApi.updatePassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PasswordApiFp = PasswordApiFp;
/**
 * PasswordApi - factory interface
 * @export
 */
var PasswordApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PasswordApiFp)(configuration);
    return {
        /**
         * Initiates an email to the specifed a token that can be used change the associated user\'s password
         * @summary Create a password reset request.
         * @param {PasswordApiRequestPasswordResetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.requestPasswordReset(requestParameters.passwordResetRequestCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the email of the user associated with the specified reset request token.
         * @summary Reset a user password via token.
         * @param {PasswordApiResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.resetPassword(requestParameters.passwordResetCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a user password using email and the existing password.
         * @summary Update a user password
         * @param {PasswordApiUpdatePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.updatePassword(requestParameters.passwordCreateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PasswordApiFactory = PasswordApiFactory;
/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */
var PasswordApi = /** @class */ (function (_super) {
    __extends(PasswordApi, _super);
    function PasswordApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initiates an email to the specifed a token that can be used change the associated user\'s password
     * @summary Create a password reset request.
     * @param {PasswordApiRequestPasswordResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.requestPasswordReset = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PasswordApiFp)(this.configuration).requestPasswordReset(requestParameters.passwordResetRequestCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the email of the user associated with the specified reset request token.
     * @summary Reset a user password via token.
     * @param {PasswordApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.resetPassword = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PasswordApiFp)(this.configuration).resetPassword(requestParameters.passwordResetCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a user password using email and the existing password.
     * @summary Update a user password
     * @param {PasswordApiUpdatePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.updatePassword = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PasswordApiFp)(this.configuration).updatePassword(requestParameters.passwordCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PasswordApi;
}(base_1.BaseAPI));
exports.PasswordApi = PasswordApi;
/**
 * RoleApi - axios parameter creator
 * @export
 */
var RoleApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add scope to role
         * @summary Add scope to role
         * @param {number} roleIdentifier
         * @param {number} scopeIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScopeToRole: function (roleIdentifier_1, scopeIdentifier_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([roleIdentifier_1, scopeIdentifier_1], args_1, true), void 0, function (roleIdentifier, scopeIdentifier, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'roleIdentifier' is not null or undefined
                            (0, common_1.assertParamExists)('addScopeToRole', 'roleIdentifier', roleIdentifier);
                            // verify required parameter 'scopeIdentifier' is not null or undefined
                            (0, common_1.assertParamExists)('addScopeToRole', 'scopeIdentifier', scopeIdentifier);
                            localVarPath = "/roles/{roleIdentifier}/scopes/{scopeIdentifier}"
                                .replace("{".concat("roleIdentifier", "}"), encodeURIComponent(String(roleIdentifier)))
                                .replace("{".concat("scopeIdentifier", "}"), encodeURIComponent(String(scopeIdentifier)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add scopes to a role
         * @summary Add scopes to a role
         * @param {string} roleKey
         * @param {RoleScopes} [roleScopes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScopesToRole: function (roleKey_1, roleScopes_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([roleKey_1, roleScopes_1], args_1, true), void 0, function (roleKey, roleScopes, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'roleKey' is not null or undefined
                            (0, common_1.assertParamExists)('addScopesToRole', 'roleKey', roleKey);
                            localVarPath = "/roles/{roleKey}/scopes"
                                .replace("{".concat("roleKey", "}"), encodeURIComponent(String(roleKey)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["create:role_scope"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roleScopes, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a role
         * @summary Create a role
         * @param {RoleCreateData} [roleCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: function (roleCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([roleCreateData_1], args_1, true), void 0, function (roleCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/roles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roleCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a role
         * @summary Delete a role
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: function (key_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([key_1], args_1, true), void 0, function (key, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'key' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRole', 'key', key);
                            localVarPath = "/roles/{key}"
                                .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return roles based upon request parameters
         * @summary Get roles
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [key]
         * @param {Array<string>} [scopes]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {RoleSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: function (limit_1, id_1, key_1, scopes_1, createdById_1, deletedById_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 9; _i < arguments.length; _i++) {
                args_1[_i - 9] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, key_1, scopes_1, createdById_1, deletedById_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, key, scopes, createdById, deletedById, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getRoles', 'limit', limit);
                            localVarPath = "/roles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (key) {
                                localVarQueryParameter['key'] = key;
                            }
                            if (scopes) {
                                localVarQueryParameter['scopes'] = scopes;
                            }
                            if (createdById) {
                                localVarQueryParameter['createdById'] = createdById;
                            }
                            if (deletedById) {
                                localVarQueryParameter['deletedById'] = deletedById;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Remove a scope from a role
         * @summary Remove a scope from a role
         * @param {string} roleIdentifier
         * @param {string} scopeIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeScopeFromRole: function (roleIdentifier_1, scopeIdentifier_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([roleIdentifier_1, scopeIdentifier_1], args_1, true), void 0, function (roleIdentifier, scopeIdentifier, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'roleIdentifier' is not null or undefined
                            (0, common_1.assertParamExists)('removeScopeFromRole', 'roleIdentifier', roleIdentifier);
                            // verify required parameter 'scopeIdentifier' is not null or undefined
                            (0, common_1.assertParamExists)('removeScopeFromRole', 'scopeIdentifier', scopeIdentifier);
                            localVarPath = "/roles/{roleIdentifier}/scopes/{scopeIdentifier}"
                                .replace("{".concat("roleIdentifier", "}"), encodeURIComponent(String(roleIdentifier)))
                                .replace("{".concat("scopeIdentifier", "}"), encodeURIComponent(String(scopeIdentifier)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["delete:role_scope"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RoleApiAxiosParamCreator = RoleApiAxiosParamCreator;
/**
 * RoleApi - functional programming interface
 * @export
 */
var RoleApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RoleApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add scope to role
         * @summary Add scope to role
         * @param {number} roleIdentifier
         * @param {number} scopeIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScopeToRole: function (roleIdentifier, scopeIdentifier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addScopeToRole(roleIdentifier, scopeIdentifier, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.addScopeToRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add scopes to a role
         * @summary Add scopes to a role
         * @param {string} roleKey
         * @param {RoleScopes} [roleScopes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScopesToRole: function (roleKey, roleScopes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addScopesToRole(roleKey, roleScopes, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.addScopesToRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a role
         * @summary Create a role
         * @param {RoleCreateData} [roleCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: function (roleCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRole(roleCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.createRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a role
         * @summary Delete a role
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: function (key, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRole(key, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.deleteRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return roles based upon request parameters
         * @summary Get roles
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [key]
         * @param {Array<string>} [scopes]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {RoleSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: function (limit, id, key, scopes, createdById, deletedById, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRoles(limit, id, key, scopes, createdById, deletedById, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.getRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Remove a scope from a role
         * @summary Remove a scope from a role
         * @param {string} roleIdentifier
         * @param {string} scopeIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeScopeFromRole: function (roleIdentifier, scopeIdentifier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeScopeFromRole(roleIdentifier, scopeIdentifier, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoleApi.removeScopeFromRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RoleApiFp = RoleApiFp;
/**
 * RoleApi - factory interface
 * @export
 */
var RoleApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RoleApiFp)(configuration);
    return {
        /**
         * Add scope to role
         * @summary Add scope to role
         * @param {RoleApiAddScopeToRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScopeToRole: function (requestParameters, options) {
            return localVarFp.addScopeToRole(requestParameters.roleIdentifier, requestParameters.scopeIdentifier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add scopes to a role
         * @summary Add scopes to a role
         * @param {RoleApiAddScopesToRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScopesToRole: function (requestParameters, options) {
            return localVarFp.addScopesToRole(requestParameters.roleKey, requestParameters.roleScopes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a role
         * @summary Create a role
         * @param {RoleApiCreateRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createRole(requestParameters.roleCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a role
         * @summary Delete a role
         * @param {RoleApiDeleteRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: function (requestParameters, options) {
            return localVarFp.deleteRole(requestParameters.key, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return roles based upon request parameters
         * @summary Get roles
         * @param {RoleApiGetRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: function (requestParameters, options) {
            return localVarFp.getRoles(requestParameters.limit, requestParameters.id, requestParameters.key, requestParameters.scopes, requestParameters.createdById, requestParameters.deletedById, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Remove a scope from a role
         * @summary Remove a scope from a role
         * @param {RoleApiRemoveScopeFromRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeScopeFromRole: function (requestParameters, options) {
            return localVarFp.removeScopeFromRole(requestParameters.roleIdentifier, requestParameters.scopeIdentifier, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RoleApiFactory = RoleApiFactory;
/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
var RoleApi = /** @class */ (function (_super) {
    __extends(RoleApi, _super);
    function RoleApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add scope to role
     * @summary Add scope to role
     * @param {RoleApiAddScopeToRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    RoleApi.prototype.addScopeToRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoleApiFp)(this.configuration).addScopeToRole(requestParameters.roleIdentifier, requestParameters.scopeIdentifier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add scopes to a role
     * @summary Add scopes to a role
     * @param {RoleApiAddScopesToRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    RoleApi.prototype.addScopesToRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoleApiFp)(this.configuration).addScopesToRole(requestParameters.roleKey, requestParameters.roleScopes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a role
     * @summary Create a role
     * @param {RoleApiCreateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    RoleApi.prototype.createRole = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RoleApiFp)(this.configuration).createRole(requestParameters.roleCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a role
     * @summary Delete a role
     * @param {RoleApiDeleteRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    RoleApi.prototype.deleteRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoleApiFp)(this.configuration).deleteRole(requestParameters.key, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return roles based upon request parameters
     * @summary Get roles
     * @param {RoleApiGetRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    RoleApi.prototype.getRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoleApiFp)(this.configuration).getRoles(requestParameters.limit, requestParameters.id, requestParameters.key, requestParameters.scopes, requestParameters.createdById, requestParameters.deletedById, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Remove a scope from a role
     * @summary Remove a scope from a role
     * @param {RoleApiRemoveScopeFromRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    RoleApi.prototype.removeScopeFromRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoleApiFp)(this.configuration).removeScopeFromRole(requestParameters.roleIdentifier, requestParameters.scopeIdentifier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RoleApi;
}(base_1.BaseAPI));
exports.RoleApi = RoleApi;
/**
 * ScopeApi - axios parameter creator
 * @export
 */
var ScopeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a scope
         * @summary Create a scope
         * @param {ScopeCreateData} [scopeCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScope: function (scopeCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([scopeCreateData_1], args_1, true), void 0, function (scopeCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/scopes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scopeCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a scope
         * @summary Delete a scope
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScope: function (key_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([key_1], args_1, true), void 0, function (key, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'key' is not null or undefined
                            (0, common_1.assertParamExists)('deleteScope', 'key', key);
                            localVarPath = "/scopes/{key}"
                                .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return scopes based upon request parameters
         * @summary Get scopes
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [key]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {ScopeSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopes: function (limit_1, id_1, key_1, createdById_1, deletedById_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, key_1, createdById_1, deletedById_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, key, createdById, deletedById, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getScopes', 'limit', limit);
                            localVarPath = "/scopes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (key) {
                                localVarQueryParameter['key'] = key;
                            }
                            if (createdById) {
                                localVarQueryParameter['createdById'] = createdById;
                            }
                            if (deletedById) {
                                localVarQueryParameter['deletedById'] = deletedById;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ScopeApiAxiosParamCreator = ScopeApiAxiosParamCreator;
/**
 * ScopeApi - functional programming interface
 * @export
 */
var ScopeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ScopeApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a scope
         * @summary Create a scope
         * @param {ScopeCreateData} [scopeCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScope: function (scopeCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createScope(scopeCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScopeApi.createScope']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a scope
         * @summary Delete a scope
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScope: function (key, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteScope(key, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScopeApi.deleteScope']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return scopes based upon request parameters
         * @summary Get scopes
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [key]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {ScopeSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopes: function (limit, id, key, createdById, deletedById, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getScopes(limit, id, key, createdById, deletedById, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScopeApi.getScopes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ScopeApiFp = ScopeApiFp;
/**
 * ScopeApi - factory interface
 * @export
 */
var ScopeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ScopeApiFp)(configuration);
    return {
        /**
         * Create a scope
         * @summary Create a scope
         * @param {ScopeApiCreateScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScope: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createScope(requestParameters.scopeCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a scope
         * @summary Delete a scope
         * @param {ScopeApiDeleteScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScope: function (requestParameters, options) {
            return localVarFp.deleteScope(requestParameters.key, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return scopes based upon request parameters
         * @summary Get scopes
         * @param {ScopeApiGetScopesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopes: function (requestParameters, options) {
            return localVarFp.getScopes(requestParameters.limit, requestParameters.id, requestParameters.key, requestParameters.createdById, requestParameters.deletedById, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ScopeApiFactory = ScopeApiFactory;
/**
 * ScopeApi - object-oriented interface
 * @export
 * @class ScopeApi
 * @extends {BaseAPI}
 */
var ScopeApi = /** @class */ (function (_super) {
    __extends(ScopeApi, _super);
    function ScopeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a scope
     * @summary Create a scope
     * @param {ScopeApiCreateScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScopeApi
     */
    ScopeApi.prototype.createScope = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ScopeApiFp)(this.configuration).createScope(requestParameters.scopeCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a scope
     * @summary Delete a scope
     * @param {ScopeApiDeleteScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScopeApi
     */
    ScopeApi.prototype.deleteScope = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScopeApiFp)(this.configuration).deleteScope(requestParameters.key, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return scopes based upon request parameters
     * @summary Get scopes
     * @param {ScopeApiGetScopesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScopeApi
     */
    ScopeApi.prototype.getScopes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScopeApiFp)(this.configuration).getScopes(requestParameters.limit, requestParameters.id, requestParameters.key, requestParameters.createdById, requestParameters.deletedById, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ScopeApi;
}(base_1.BaseAPI));
exports.ScopeApi = ScopeApi;
/**
 * ServiceApi - axios parameter creator
 * @export
 */
var ServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add service role
         * @summary Add service role
         * @param {string} uuid
         * @param {ServiceRoleCreateData} [serviceRoleCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addServiceRole: function (uuid_1, serviceRoleCreateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1, serviceRoleCreateData_1], args_1, true), void 0, function (uuid, serviceRoleCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('addServiceRole', 'uuid', uuid);
                            localVarPath = "/services/{uuid}/roles"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["update:service"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(serviceRoleCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create service
         * @summary Create service
         * @param {ServiceCreateData} [serviceCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService: function (serviceCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceCreateData_1], args_1, true), void 0, function (serviceCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/services";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["create:service"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(serviceCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get service
         * @summary Get service
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getService', 'uuid', uuid);
                            localVarPath = "/services/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:service"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get service roles
         * @summary Get service roles
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceRoles: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getServiceRoles', 'uuid', uuid);
                            localVarPath = "/services/{uuid}/roles"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:service"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get services
         * @summary Get services
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: function (limit_1, offset_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, offset_1], args_1, true), void 0, function (limit, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getServices', 'limit', limit);
                            localVarPath = "/services";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:service"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ServiceApiAxiosParamCreator = ServiceApiAxiosParamCreator;
/**
 * ServiceApi - functional programming interface
 * @export
 */
var ServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add service role
         * @summary Add service role
         * @param {string} uuid
         * @param {ServiceRoleCreateData} [serviceRoleCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addServiceRole: function (uuid, serviceRoleCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addServiceRole(uuid, serviceRoleCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ServiceApi.addServiceRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create service
         * @summary Create service
         * @param {ServiceCreateData} [serviceCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService: function (serviceCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createService(serviceCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ServiceApi.createService']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get service
         * @summary Get service
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getService(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ServiceApi.getService']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get service roles
         * @summary Get service roles
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceRoles: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getServiceRoles(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ServiceApi.getServiceRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get services
         * @summary Get services
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: function (limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getServices(limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ServiceApi.getServices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ServiceApiFp = ServiceApiFp;
/**
 * ServiceApi - factory interface
 * @export
 */
var ServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ServiceApiFp)(configuration);
    return {
        /**
         * Add service role
         * @summary Add service role
         * @param {ServiceApiAddServiceRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addServiceRole: function (requestParameters, options) {
            return localVarFp.addServiceRole(requestParameters.uuid, requestParameters.serviceRoleCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create service
         * @summary Create service
         * @param {ServiceApiCreateServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createService(requestParameters.serviceCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get service
         * @summary Get service
         * @param {ServiceApiGetServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService: function (requestParameters, options) {
            return localVarFp.getService(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get service roles
         * @summary Get service roles
         * @param {ServiceApiGetServiceRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceRoles: function (requestParameters, options) {
            return localVarFp.getServiceRoles(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get services
         * @summary Get services
         * @param {ServiceApiGetServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: function (requestParameters, options) {
            return localVarFp.getServices(requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ServiceApiFactory = ServiceApiFactory;
/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
var ServiceApi = /** @class */ (function (_super) {
    __extends(ServiceApi, _super);
    function ServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add service role
     * @summary Add service role
     * @param {ServiceApiAddServiceRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    ServiceApi.prototype.addServiceRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ServiceApiFp)(this.configuration).addServiceRole(requestParameters.uuid, requestParameters.serviceRoleCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create service
     * @summary Create service
     * @param {ServiceApiCreateServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    ServiceApi.prototype.createService = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ServiceApiFp)(this.configuration).createService(requestParameters.serviceCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get service
     * @summary Get service
     * @param {ServiceApiGetServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    ServiceApi.prototype.getService = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ServiceApiFp)(this.configuration).getService(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get service roles
     * @summary Get service roles
     * @param {ServiceApiGetServiceRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    ServiceApi.prototype.getServiceRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ServiceApiFp)(this.configuration).getServiceRoles(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get services
     * @summary Get services
     * @param {ServiceApiGetServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    ServiceApi.prototype.getServices = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ServiceApiFp)(this.configuration).getServices(requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ServiceApi;
}(base_1.BaseAPI));
exports.ServiceApi = ServiceApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create user
         * @summary Create user
         * @param {UserCreateData} [userCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (userCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userCreateData_1], args_1, true), void 0, function (userCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["create:company-user"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete user
         * @summary Delete user
         * @param {string} uuid The UUID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('deleteUser', 'uuid', uuid);
                            localVarPath = "/users/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["update:user"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create user
         * @summary Get user
         * @param {string} uuid The UUID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (uuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([uuid_1], args_1, true), void 0, function (uuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            (0, common_1.assertParamExists)('getUser', 'uuid', uuid);
                            localVarPath = "/users/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["get:user"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get users
         * @summary Get users
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [accountId]
         * @param {Array<number>} [financeAccountId] The finance account ID that the user belongs to
         * @param {Array<number>} [companyId]
         * @param {Array<string>} [email]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {boolean} [isDeleted]
         * @param {boolean} [isDeactivated]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {UserSort} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (id_1, uuid_1, accountId_1, financeAccountId_1, companyId_1, email_1, createdById_1, deletedById_1, isDeleted_1, isDeactivated_1, offset_1, limit_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, uuid_1, accountId_1, financeAccountId_1, companyId_1, email_1, createdById_1, deletedById_1, isDeleted_1, isDeactivated_1, offset_1, limit_1, sortBy_1, order_1], args_1, true), void 0, function (id, uuid, accountId, financeAccountId, companyId, email, createdById, deletedById, isDeleted, isDeactivated, offset, limit, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["list:user"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId;
                            }
                            if (financeAccountId) {
                                localVarQueryParameter['financeAccountId'] = financeAccountId;
                            }
                            if (companyId) {
                                localVarQueryParameter['companyId'] = companyId;
                            }
                            if (email) {
                                localVarQueryParameter['email'] = email;
                            }
                            if (createdById) {
                                localVarQueryParameter['createdById'] = createdById;
                            }
                            if (deletedById) {
                                localVarQueryParameter['deletedById'] = deletedById;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (isDeactivated !== undefined) {
                                localVarQueryParameter['isDeactivated'] = isDeactivated;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update user
         * @summary Update user
         * @param {UserUpdateData} [userUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (userUpdateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userUpdateData_1], args_1, true), void 0, function (userUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["update:user"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
var UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create user
         * @summary Create user
         * @param {UserCreateData} [userCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (userCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createUser(userCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.createUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete user
         * @summary Delete user
         * @param {string} uuid The UUID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteUser(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.deleteUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create user
         * @summary Get user
         * @param {string} uuid The UUID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUser(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.getUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get users
         * @summary Get users
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<number>} [accountId]
         * @param {Array<number>} [financeAccountId] The finance account ID that the user belongs to
         * @param {Array<number>} [companyId]
         * @param {Array<string>} [email]
         * @param {Array<number>} [createdById]
         * @param {Array<number>} [deletedById]
         * @param {boolean} [isDeleted]
         * @param {boolean} [isDeactivated]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {UserSort} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (id, uuid, accountId, financeAccountId, companyId, email, createdById, deletedById, isDeleted, isDeactivated, offset, limit, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUsers(id, uuid, accountId, financeAccountId, companyId, email, createdById, deletedById, isDeleted, isDeactivated, offset, limit, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.getUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update user
         * @summary Update user
         * @param {UserUpdateData} [userUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (userUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUser(userUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.updateUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
var UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         * Create user
         * @summary Create user
         * @param {UserApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createUser(requestParameters.userCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete user
         * @summary Delete user
         * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (requestParameters, options) {
            return localVarFp.deleteUser(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create user
         * @summary Get user
         * @param {UserApiGetUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (requestParameters, options) {
            return localVarFp.getUser(requestParameters.uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get users
         * @summary Get users
         * @param {UserApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getUsers(requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.financeAccountId, requestParameters.companyId, requestParameters.email, requestParameters.createdById, requestParameters.deletedById, requestParameters.isDeleted, requestParameters.isDeactivated, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update user
         * @summary Update user
         * @param {UserApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.updateUser(requestParameters.userUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create user
     * @summary Create user
     * @param {UserApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.createUser = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.UserApiFp)(this.configuration).createUser(requestParameters.userCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete user
     * @summary Delete user
     * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.deleteUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).deleteUser(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create user
     * @summary Get user
     * @param {UserApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.getUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).getUser(requestParameters.uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get users
     * @summary Get users
     * @param {UserApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.getUsers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.UserApiFp)(this.configuration).getUsers(requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.financeAccountId, requestParameters.companyId, requestParameters.email, requestParameters.createdById, requestParameters.deletedById, requestParameters.isDeleted, requestParameters.isDeactivated, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update user
     * @summary Update user
     * @param {UserApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.updateUser = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.UserApiFp)(this.configuration).updateUser(requestParameters.userUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
/**
 * UserDeactivationApi - axios parameter creator
 * @export
 */
var UserDeactivationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create user deactivation
         * @summary Create user deactivations
         * @param {UserDeactivationCreateData} [userDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserDeactivation: function (userDeactivationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userDeactivationCreateData_1], args_1, true), void 0, function (userDeactivationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/userDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userDeactivationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a user deactivation
         * @summary Delete a user deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserDeactivation: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteUserDeactivation', 'id', id);
                            localVarPath = "/userDeactivations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return user deactivations based upon request parameters
         * @summary Get user deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [userId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDeactivations: function (limit_1, id_1, userId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 13; _i < arguments.length; _i++) {
                args_1[_i - 13] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, userId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, userId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getUserDeactivations', 'limit', limit);
                            localVarPath = "/userDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["auth:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (userId) {
                                localVarQueryParameter['userId'] = userId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UserDeactivationApiAxiosParamCreator = UserDeactivationApiAxiosParamCreator;
/**
 * UserDeactivationApi - functional programming interface
 * @export
 */
var UserDeactivationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserDeactivationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create user deactivation
         * @summary Create user deactivations
         * @param {UserDeactivationCreateData} [userDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserDeactivation: function (userDeactivationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createUserDeactivation(userDeactivationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserDeactivationApi.createUserDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a user deactivation
         * @summary Delete a user deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserDeactivation: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteUserDeactivation(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserDeactivationApi.deleteUserDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return user deactivations based upon request parameters
         * @summary Get user deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [userId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDeactivations: function (limit, id, userId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserDeactivations(limit, id, userId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserDeactivationApi.getUserDeactivations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UserDeactivationApiFp = UserDeactivationApiFp;
/**
 * UserDeactivationApi - factory interface
 * @export
 */
var UserDeactivationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserDeactivationApiFp)(configuration);
    return {
        /**
         * Create user deactivation
         * @summary Create user deactivations
         * @param {UserDeactivationApiCreateUserDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserDeactivation: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createUserDeactivation(requestParameters.userDeactivationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a user deactivation
         * @summary Delete a user deactivation
         * @param {UserDeactivationApiDeleteUserDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserDeactivation: function (requestParameters, options) {
            return localVarFp.deleteUserDeactivation(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return user deactivations based upon request parameters
         * @summary Get user deactivations
         * @param {UserDeactivationApiGetUserDeactivationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDeactivations: function (requestParameters, options) {
            return localVarFp.getUserDeactivations(requestParameters.limit, requestParameters.id, requestParameters.userId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserDeactivationApiFactory = UserDeactivationApiFactory;
/**
 * UserDeactivationApi - object-oriented interface
 * @export
 * @class UserDeactivationApi
 * @extends {BaseAPI}
 */
var UserDeactivationApi = /** @class */ (function (_super) {
    __extends(UserDeactivationApi, _super);
    function UserDeactivationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create user deactivation
     * @summary Create user deactivations
     * @param {UserDeactivationApiCreateUserDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDeactivationApi
     */
    UserDeactivationApi.prototype.createUserDeactivation = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.UserDeactivationApiFp)(this.configuration).createUserDeactivation(requestParameters.userDeactivationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a user deactivation
     * @summary Delete a user deactivation
     * @param {UserDeactivationApiDeleteUserDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDeactivationApi
     */
    UserDeactivationApi.prototype.deleteUserDeactivation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UserDeactivationApiFp)(this.configuration).deleteUserDeactivation(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return user deactivations based upon request parameters
     * @summary Get user deactivations
     * @param {UserDeactivationApiGetUserDeactivationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDeactivationApi
     */
    UserDeactivationApi.prototype.getUserDeactivations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UserDeactivationApiFp)(this.configuration).getUserDeactivations(requestParameters.limit, requestParameters.id, requestParameters.userId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserDeactivationApi;
}(base_1.BaseAPI));
exports.UserDeactivationApi = UserDeactivationApi;
